import { Component, OnInit, Input, ChangeDetectionStrategy, OnChanges, SimpleChanges, OnDestroy } from '@angular/core';
import { FollowTrainService } from '../follow-train.service';
import { map, take, takeUntil } from 'rxjs/operators';
import { Point } from 'geojson';
import { MapElement } from '../../../../shared/map/map-element.model';
import { Subject, Observable } from 'rxjs';

@Component({
  selector: 'qm-follow-train-button',
  templateUrl: './follow-train-button.component.html',
  styleUrls: ['./follow-train-button.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class FollowTrainButtonComponent implements OnInit, OnChanges, OnDestroy {

  @Input()
  public feature: MapElement<Point>;

  public isFollowing$: Observable<boolean>;

  private ngUnsubscribe = new Subject<void>();

  constructor(private followTrainService: FollowTrainService) { }

  ngOnInit() {
    this.subscribeTrain();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.feature.isFirstChange() || changes.feature.currentValue.id !== changes.feature.previousValue.id) {
      this.subscribeTrain();
    }
  }

  ngOnDestroy() {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }

  private subscribeTrain() {
    this.isFollowing$ = this.followTrainService.selectedTrain$
      .pipe(
        takeUntil(this.ngUnsubscribe),
        map(train => train !== null && train.properties._id === this.feature.properties._id)
      );
  }

  async toggleFollowing() {
    const isFollowing = await this.isFollowing$.pipe(take(1)).toPromise();
    this.followTrainService.followTrain(isFollowing ? null : this.feature);
  }
}
